import { mdiDatabaseSearchOutline } from '@mdi/js'

export default [{
    subheader: 'ONE DATABASE',
    resource: 'odb',
    action: 'read',
  },
  {
    title: 'Norms',
    icon: mdiDatabaseSearchOutline,
    to: 'odb-norms',
    resource: 'odb',
    action: 'read',
  },
]
